import { Tooltip } from 'antd';
import { ApartmentOutlined, DeploymentUnitOutlined, FileTextOutlined, HomeOutlined, SafetyOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';
import styles from './SettingNav.module.scss';

type SettingNavKey = 'user' | 'tenant' | 'environment' | 'privacy' | 'disclaimer';

interface NavItem {
  key: SettingNavKey;
  label: string;
  icon: ReactNode;
}

interface Props {
  active: SettingNavKey;
  onChange: (key: SettingNavKey) => void;
  onHome: () => void;
  isAdmin?: boolean;
}

const items: NavItem[] = [
  { key: 'user', label: 'User Dashboard', icon: <UserOutlined /> },
  { key: 'tenant', label: 'Tenant Dashboard', icon: <ApartmentOutlined /> },
  { key: 'environment', label: 'Client Environment Dashboard', icon: <DeploymentUnitOutlined /> },
];

const adminItems: NavItem[] = [
  { key: 'privacy', label: 'Privacy Notice', icon: <SafetyOutlined /> },
  { key: 'disclaimer', label: 'Disclaimer', icon: <FileTextOutlined /> },
];

const SettingNav = ({ active, onChange, onHome, isAdmin = false }: Props) => {
  const visibleItems = isAdmin ? [...items, ...adminItems] : items;
  return (
    <nav className={styles.nav}>
      <div className={styles.logo}>AI</div>
      <div className={styles.subtitle}>Settings</div>
      <div className={styles.homeSection}>
        <Tooltip title="Home" placement="right">
          <button className={styles.item} onClick={onHome} aria-label="Home">
            <HomeOutlined />
          </button>
        </Tooltip>
      </div>
      <div className={styles.divider} />
      <div className={styles.items}>
        {visibleItems.map((it) => {
          const activeItem = it.key === active;
          return (
            <Tooltip key={it.key} title={it.label} placement="right">
              <button
                className={activeItem ? styles.itemActive : styles.item}
                onClick={() => onChange(it.key)}
                aria-label={it.label}
              >
                {it.icon}
              </button>
            </Tooltip>
          );
        })}
      </div>
      <div className={styles.spacer} />
      <div className={styles.bottomItems}>
        <Tooltip title="Settings" placement="right">
          <button
            className={`${styles.itemActive} ${styles.settingsActive} ${styles.itemDisabled}`}
            aria-label="Settings"
            disabled
          >
            <SettingOutlined />
          </button>
        </Tooltip>
      </div>
    </nav>
  );
};

export default SettingNav;
